module.exports = __webpack_public_path__ + "static/img/brand1.48c7c46f.png";